import { RigidBody } from "@react-three/rapier";
import { useFrame, useThree } from "@react-three/fiber";
import { useRef } from "react";

const Surface = () => {
  const materialRef = useRef();
  const { camera } = useThree();

  useFrame(() => {
    if (materialRef.current) {
      materialRef.current.updateCameraPosition(camera);
    }
  });

  return (
    <RigidBody type="fixed" friction={0.1} restitution={0.1} position-y={-2} ccd={false}>
      <mesh receiveShadow>
        <boxGeometry args={[1500, 2, 1500]} />
        <gradientMaterial ref={materialRef} />
      </mesh>
    </RigidBody>
  );
};

export default Surface;
